import type { ReactNode } from 'react';

import styles from './page-container.module.scss';

export function PageContainer({ children }: { children: ReactNode }) {
  return <div className={styles.container}>{children}</div>;
}
